import { Aligment, MaxHeight } from "./types"

interface Layout {
    maxHeight?: MaxHeight
    align?: Aligment
}


export type LayoutFunction = ReturnType<typeof getLayoutFunction>

export function getLayoutFunction(target: HTMLInputElement, layout: Layout) {

    return (dim: { height: number } | undefined) => {

        return getLayout(target, layout, dim)

    }

}

export function getLayout(target: HTMLInputElement, layout: Layout, dimensions: { height: number } | undefined) {

    const { align } = layout

    const targetRect = target.getBoundingClientRect()

    const body = target.ownerDocument.body.getBoundingClientRect()

    const docElement = target.ownerDocument.documentElement
    const viewHeight = docElement.clientHeight
    const viewWidth = docElement.clientWidth

    let top: number | undefined
    let bottom: number | undefined
    let left: number | undefined
    let right: number | undefined
    let maxHeight: number | undefined

    const requestedMaxHeight = getMaxHeight(layout.maxHeight, viewHeight)

    if (align) {

        const horizontalMargin = 5

        if (align === "left") {
            right = (viewWidth - (targetRect.left - body.left)) + horizontalMargin
        }
        else {
            left = horizontalMargin + targetRect.right - body.left
        }

        const height = dimensions
            // The +xxx below has is there to account for any padding/extra space between the outer element and the popup itself
            // (e.g., borders, padding...)
            // No idea on how to calculate that properly, so this should do as an approximation
            ? Math.min(requestedMaxHeight, dimensions.height + 20)
            : requestedMaxHeight

        top = targetRect.top + (targetRect.height / 2);
        [top, bottom] = getVerticalPosition(top!, height, body, viewHeight)

    }
    else {

        [top, bottom, maxHeight] = targetRect.bottom < (viewHeight / 2)
            ? [targetRect.bottom, undefined, viewHeight - targetRect.bottom]
            : [undefined, targetRect.top, targetRect.top]

        left = targetRect.left - body.left
        right = viewWidth - (targetRect.right - body.left)

        if (requestedMaxHeight) {
            maxHeight = Math.min(requestedMaxHeight, maxHeight)
        }

    }


    return {
        rect: targetRect,
        top: top === undefined ? undefined : top - body.top,
        bottom: bottom === undefined ? undefined : viewHeight - (bottom - body.top),
        left,
        right,
        maxHeight
    }

}


function getVerticalPosition(targetY: number, height: number, body: DOMRect, viewHeight: number) {

    targetY -= body.top

    const h2 = height / 2

    let top = targetY - h2
    let bottom = targetY + h2

    if (top < 0) {
        bottom -= top
        top = 0
    }

    const overflow = bottom - viewHeight

    if (overflow > 0) {
        top -= overflow
        bottom -= overflow
    }

    return [top, bottom]

}

function getMaxHeight(spec: MaxHeight | undefined, viewHeight: number) {

    if (spec) {

        const { px, vh } = spec

        if (px) {
            return px
        }

        if (vh) {
            return (vh * viewHeight / 100)
        }

    }

    return viewHeight

}    
